import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { LocaleService } from '@upr-web-primer/locale';
import { MsGuestsService } from '@upr-web-primer/ms-guests';
import { LocalStorageService } from '@upr-web-primer/storage';
import { UdxSpinnerService } from '@upr-web-primer/udx-spinner';
import { WINDOW } from '@upr-web-primer/window';
import { appRoutes } from '../../../config/app-default.constant';
import { defaultValues } from '../../../config/defaultValues.constant';
import { CommonUtilityService } from '../../services/common-utility.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: false,
})
export class PageNotFoundComponent implements OnInit {
  pageLabels: any;
  @ViewChild('birthDayContainer', { read: ViewContainerRef, static: true })
  birthDayContainer!: ViewContainerRef;
  constructor(
    @Inject('AppRoutes') public appRoutes: any,
    @Inject('GlobalDefaults') public globalDefault: any,
    private readonly commonUtilityService: CommonUtilityService,
    public spinner: UdxSpinnerService,
    private readonly guestsService: MsGuestsService,
    public router: Router,
    public route: ActivatedRoute,
    @Inject(WINDOW) private readonly window: Window,
    private readonly localStorage: LocalStorageService,
    @Inject('NotFoundPage') private readonly notFoundPage: string,
    private readonly localeService: LocaleService,
    @Inject('WebContentUrl') public webContentUrl: string,
  ) {
    this.pageLabels = this.commonUtilityService.getResolvedPageData();
  }

  ngOnInit(): void {
    const isNavigate = environment.config?.dashboard?.isNavigate;
    const guestId = this.localStorage.getItem('LOGGEDIN_GUEST_ID') || '';
    const oauthLoginId = this.localStorage.getItem('OAUTH_LOGIN_GID') || '';
    if (
      guestId &&
      oauthLoginId &&
      this.guestsService.helper.isAuth() &&
      isNavigate
    ) {
      this.goToHomepage();
    } else if (
      !guestId &&
      !oauthLoginId &&
      !this.guestsService.helper.isAuth() &&
      isNavigate
    ) {
      this.commonUtilityService.changeRoute(this.appRoutes.LOGIN);
    } else {
      if (
        this.route.snapshot.url?.some(
          (segment) => segment.path === 'search-results',
        )
      ) {
        this.searchresult();
      } else {
        const url = this.route.snapshot.url;
        if (!url || url.length === 0) {
          const defaultLogin = [
            defaultValues.DEFAULT_ROUTE_LANGUAGE,
            defaultValues.DEFAULT_ROUTE_COUNTRY,
            appRoutes.LOGIN,
          ].join('/');
          if (
            this.window?.location?.origin?.includes('web-local.use.ucdp.net') &&
            !this.window?.location?.origin?.includes(
              'web-local.use.ucdp.net:4202',
            )
          ) {
            return;
          }
          this.router.navigateByUrl(defaultLogin);
          return;
        }
        let defaultUrl = url.join('/');
        if (defaultUrl.indexOf('.html') === -1) {
          defaultUrl += '/index.html';
        }
        if (
          this.window.location.origin.includes('localhost') ||
          this.window.location.pathname.includes(this.notFoundPage)
        ) {
          this.getContent();
          return;
        }
        const notFoundUrl =
          [
            defaultValues.DEFAULT_ROUTE_LANGUAGE,
            defaultValues.DEFAULT_ROUTE_COUNTRY,
          ].join('/') + this.notFoundPage;
        this.commonUtilityService.changeUrl(notFoundUrl);
      }
    }
  }

  /**
   * goToPage - It will redirect to the specified route
   * @param type : specify which route to navigate
   */

  goToPage(type: any): any {
    switch (type) {
      case this.globalDefault.BIRTHDAY_DISCOUNT:
        this.commonUtilityService.changeRoute(this.appRoutes.DASHBOARD);
        break;
    }
  }

  goToHomepage(): void {
    this.commonUtilityService.changeRoute(this.appRoutes.DASHBOARD);
  }

  getContent(): void {
    this.spinner.show();
    this.commonUtilityService
      .fetchTridionContent('birthday-content')
      ?.subscribe((data: any) => {
        if (data && data.length > 0) this.initializeUI(data[0].elements);
      });
  }
  initializeUI(elements: any): void {
    this.birthDayContainer?.clear();
    this.spinner.hide();
    this.commonUtilityService.loadTridionUtility(
      this.birthDayContainer,
      elements,
    );
  }

  // Check if the 'search-results' segment is present in the URL
  searchresult(): any {
    if (
      this.route.snapshot.url.some(
        (segment) => segment.path === 'search-results',
      )
    ) {
      const urlParams = window.location.hash;
      if (!urlParams) {
        return true;
      }
      const localeObj = this.localeService.getFromUrl();
      const language = localeObj?.language || 'en';
      const country = localeObj?.country || 'us';
      const searchQuery = urlParams.substr(3);
      const encodedSearchQuery = decodeURIComponent(searchQuery);
      const redirectUrl = `${this.webContentUrl}/${language}/${country}/search-results/index.html#q=${encodedSearchQuery}`;
      window.location.href = redirectUrl;
      return false; // Prevent further action
    }
    return true;
  }
}
